import { Col, Form, Input, InputNumber, Row, Select } from "antd";
import { TASK_CATEGORY_OPTIONS } from "../constants";
import type { TaskPriority } from "../types";

const PRIORITY_OPTIONS: { value: TaskPriority; label: string }[] = [
	{ value: "LOW", label: "Past" },
	{ value: "MEDIUM", label: "O'rta" },
	{ value: "HIGH", label: "Yuqori" },
	{ value: "URGENT", label: "Shoshilinch" },
];

export function TaskTypeForm() {
	return (
		<>
			<Row gutter={16}>
				<Col span={24}>
					<Form.Item
						name="name"
						label="Nomi"
						rules={[
							{ required: true, message: "Nomini kiriting" },
							{ max: 255, message: "Maksimum 255 ta belgi" },
						]}
					>
						<Input placeholder="Masalan: Tozalash" id="task-type-name" />
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={12}>
					<Form.Item
						name="category"
						label="Toifa"
						rules={[{ required: true, message: "Toifani tanlang" }]}
					>
						<Select
							options={TASK_CATEGORY_OPTIONS}
							placeholder="Toifani tanlang"
							id="task-type-category"
						/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="defaultPriority" label="Standart ustuvorlik">
						<Select options={PRIORITY_OPTIONS} placeholder="Tanlang" id="task-type-priority" />
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={12}>
					<Form.Item name="sortOrder" label="Tartib raqami">
						<InputNumber min={0} className="w-full" id="task-type-sortOrder" />
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={16}>
				<Col span={24}>
					<Form.Item name="description" label="Izoh" rules={[{ max: 1000 }]}>
						<Input.TextArea rows={3} placeholder="Qisqacha izoh" id="task-type-description" />
					</Form.Item>
				</Col>
			</Row>
		</>
	);
}
